<h1>The web API returns:</h1>
<div>
  <p><strong>Name: </strong> {{profile?.name}}</p>
</div>

<div class="footer-text">
  Web API: {{brennerSoftwareApiEndpoint}}
</div>
